var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner-page"},[_c('CpRequestAlert'),_c('Preview'),(_vm.user)?_c('SearchResult',{attrs:{"preview":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }